import { createAction, props } from '@ngrx/store';
import {
	ExecuteGenerateProductionFileModel,
	CreateRebateSubmissionFileModel,
	FilterSearchRequest,
	GetSubmissionFileVersionsModel,
	RebateSubmissionFileModel,
	SubmittedDataSearchResponseModel,
	RebateSubmissionFileStatusChangedNotification,
	SearchRequest,
	SearchResponse,
	SubmissionFileGroupModel,
	SubmittedDataVersionInfoModel,
	SubmittedDataSearchFilterModel,
	ExecuteSubmitProductionFileModel,
	ExecuteFinalizeProductionFileModel,
	ListOptionModel
} from '@twrx-api-models';
import { DownloadSubmissionFileRequest } from 'app/models/dto/download-submission-file-request';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';

export enum SubmissionFilesActions {
	LoadSubmissionFiles = '[SubmissionFiles] LoadSubmissionFiles',
	SubmissionFilesLoaded = '[SubmissionFiles] SubmissionFilesLoaded',

	LoadSubmissionFileAggregatorOptions = '[SubmissionFiles] LoadSubmissionFileAggregatorOptions',
	SubmissionFileAggregatorOptionsLoaded = '[SubmissionFiles] SubmissionFileAggregatorOptionsLoaded',

	LoadSubmissionFileVersions = '[SubmissionFiles] LoadSubmissionFileVersions',
	SubmissionFileVersionsLoaded = '[SubmissionFiles] SubmissionFileVersionsLoaded',

	LoadSubmittedData = '[SubmissionFiles] LoadSubmittedData',
	SubmittedDataLoaded = '[SubmissionFiles] SubmittedDataLoaded',

	LoadSubmittedDataInfo = '[SubmissionFiles] LoadSubmittedDataInfo',
	SubmittedDataInfoLoaded = '[SubmissionFiles] SubmittedDataInfoLoaded',
	SubmittedDataInfoFailed = '[SubmissionFiles] SubmittedDataInfoFailed',

	ResetSubmittedData = '[SubmissionFiles] ResetSubmittedData',

	GenerateSubmissionFile = '[SubmissionFiles] GenerateSubmissionFile',
	SubmissionFileGenerated = '[SubmissionFiles] SubmissionFileGenerated',

	GenerateProductionSubmissionFile = '[SubmissionFiles] GenerateProductionSubmissionFile',
	ProductionSubmissionFileGenerated = '[SubmissionFiles] ProductionSubmissionFileGenerated',

	SubmitProductionSubmissionFile = '[SubmissionFiles] SubmitProductionSubmissionFile',
	ProductionSubmissionFileSubmitted = '[SubmissionFiles] ProductionSubmissionFileSubmitted',

	FinalizeProductionSubmissionFile = '[SubmissionFiles] FinalizeProductionSubmissionFile',
	ProductionSubmissionFileFinalized = '[SubmissionFiles] ProductionSubmissionFileFinalized',

	DownloadSubmissionFile = '[SubmissionFiles] DownloadSubmissionFile',
	SubmissionFileDownloading = '[SubmissionFiles] SubmissionFileDownloading',
	SubmissionFileDownloaded = '[SubmissionFiles] SubmissionFileDownloaded',

	SubmissionFileStatusUpdatedEvent = '[SubmissionFiles] SubmissionFileStatusUpdatedEvent',

	ErrorOccurred = '[SubmissionFiles] ErrorOccurred'
}

export const loadSubmissionFiles = createAction(
	SubmissionFilesActions.LoadSubmissionFiles,
	props<ActionRequestPayload<SearchRequest>>()
);

export const submissionFilesLoaded = createAction(
	SubmissionFilesActions.SubmissionFilesLoaded,
	props<ActionResponsePayload<SearchResponse<SubmissionFileGroupModel>>>()
);

export const loadSubmissionFileAggregatorOptions = createAction(
	SubmissionFilesActions.LoadSubmissionFileAggregatorOptions
);

export const submissionFileAggregatorOptionsLoaded = createAction(
	SubmissionFilesActions.SubmissionFileAggregatorOptionsLoaded,
	props<ActionResponsePayload<ListOptionModel<number>[]>>()
);

export const loadSubmissionFileVersions = createAction(
	SubmissionFilesActions.LoadSubmissionFileVersions,
	props<ActionRequestPayload<GetSubmissionFileVersionsModel>>()
);

export const submissionFileVersionsLoaded = createAction(
	SubmissionFilesActions.SubmissionFileVersionsLoaded,
	props<
		ActionResponsePayload<SearchResponse<RebateSubmissionFileModel>> & {
			key: string;
		}
	>()
);

export const loadSubmittedData = createAction(
	SubmissionFilesActions.LoadSubmittedData,
	props<
		ActionRequestPayload<
			FilterSearchRequest<SubmittedDataSearchFilterModel>
		>
	>()
);

export const submittedDataLoaded = createAction(
	SubmissionFilesActions.SubmittedDataLoaded,
	props<ActionResponsePayload<SubmittedDataSearchResponseModel>>()
);

export const loadSubmittedDataInfo = createAction(
	SubmissionFilesActions.LoadSubmittedDataInfo,
	props<ActionRequestPayload<number>>()
);

export const submittedDataInfoLoaded = createAction(
	SubmissionFilesActions.SubmittedDataInfoLoaded,
	props<ActionResponsePayload<SubmittedDataVersionInfoModel>>()
);

export const submittedDataInfoFailed = createAction(
	SubmissionFilesActions.SubmittedDataInfoFailed
);

export const resetSubmittedData = createAction(
	SubmissionFilesActions.ResetSubmittedData
);

export const generateSubmissionFile = createAction(
	SubmissionFilesActions.GenerateSubmissionFile,
	props<ActionRequestPayload<CreateRebateSubmissionFileModel>>()
);

export const submissionFileGenerated = createAction(
	SubmissionFilesActions.SubmissionFileGenerated
);

export const generateProductionSubmissionFile = createAction(
	SubmissionFilesActions.GenerateProductionSubmissionFile,
	props<ActionRequestPayload<ExecuteGenerateProductionFileModel>>()
);

export const productionSubmissionFileGenerated = createAction(
	SubmissionFilesActions.ProductionSubmissionFileGenerated
);

export const submitProductionSubmissionFile = createAction(
	SubmissionFilesActions.SubmitProductionSubmissionFile,
	props<ActionRequestPayload<ExecuteSubmitProductionFileModel>>()
);

export const productionSubmissionFileSubmitted = createAction(
	SubmissionFilesActions.ProductionSubmissionFileSubmitted
);

export const finalizeProductionSubmissionFile = createAction(
	SubmissionFilesActions.FinalizeProductionSubmissionFile,
	props<ActionRequestPayload<ExecuteFinalizeProductionFileModel>>()
);

export const productionSubmissionFileFinalized = createAction(
	SubmissionFilesActions.ProductionSubmissionFileFinalized
);

export const downloadSubmissionFile = createAction(
	SubmissionFilesActions.DownloadSubmissionFile,
	props<ActionRequestPayload<DownloadSubmissionFileRequest>>()
);

export const submissionFileDownloading = createAction(
	SubmissionFilesActions.SubmissionFileDownloading
);

export const submissionFileDownloaded = createAction(
	SubmissionFilesActions.SubmissionFileDownloaded
);

export const submissionFileStatusUpdated = createAction(
	SubmissionFilesActions.SubmissionFileStatusUpdatedEvent,
	props<
		ActionResponsePayload<RebateSubmissionFileStatusChangedNotification>
	>()
);

export const errorOccurred = createAction(SubmissionFilesActions.ErrorOccurred);
